'use client';

// Utils
import { combineClasses } from '@shared/utils';
import { downloadPDF } from '@/utils/pdf';
import { downloadDOCX } from '@/utils/docx';
import { buildFileName } from '@/utils/resume';

// Hooks
import useResumeData from '@/hooks/useResumeData';

// Templates
import { CV_TEMPLATES } from '@/components/template/resume';

// Old imports - kept for future multi-template support
// import { DropdownMenuLabel, DropdownMenuSeparator } from '@shared/ui';
// import ChevronLeftIcon from '@shared/icons/ChevronLeftIcon';
// import CVTemplateMenu, { LABEL_CLASSES } from '@/components/CVTemplateMenu';

// Constants
import { ExportFormat } from '@/constants/resume';
import { CV_TEMPLATE_ID } from '@shared/constants';

// Components
import SidebarDropdown, { type SidebarItemProps } from '@/components/SidebarDropdown';
const EXPORT_FORMATS = [ExportFormat.PDF, ExportFormat.DOCX] as const;

// Old types - kept for future multi-template support
// type CVTemplate = (typeof CV_TEMPLATES)[number];
// type SelectedTemplate = Pick<CVTemplate, 'id' | 'title' | 'component'>;

const ExportSidebarItem = (props: SidebarItemProps) => {
  const {
    resumeData
  } = useResumeData();

  // Old two-step state: user first picks a template, then picks a format
  // const [selectedTemplate, setSelectedTemplate] =
  //   useState<SelectedTemplate | null>(null);

  const agilityIOTemplate = CV_TEMPLATES.find(t => t.id === CV_TEMPLATE_ID.AGILITYIO);
  const handleSelectFormat = (format: ExportFormat) => {
    if (!resumeData || !agilityIOTemplate) return;
    const {
      id,
      component: TemplateComponent
    } = agilityIOTemplate;
    const fileName = buildFileName(format, resumeData.info.name);
    if (format === ExportFormat.PDF) {
      return downloadPDF(<TemplateComponent data={resumeData} />, fileName);
    }
    downloadDOCX(resumeData, fileName, id);
  };

  // Old handlers for two-step flow (reset template on close / back button)
  // const resetTemplate = () => setSelectedTemplate(null);
  // const handleOpenChange = (open: boolean) => {
  //   if (!open) resetTemplate();
  // };

  return <SidebarDropdown {...props} triggerClassName="sm:right-3" triggerAriaLabel="Open export format selector" iconVariant="stroke"
  // onOpenChange={handleOpenChange}
  data-sentry-element="SidebarDropdown" data-sentry-component="ExportSidebarItem" data-sentry-source-file="ExportSidebarItem.tsx">
      {/* Step 1 - choose a template */}
      {/* {!selectedTemplate && (
        <CVTemplateMenu onSelect={setSelectedTemplate} preventClose />
       )} */}

      {/* Step 2 - choose a format*/}
      {/* {selectedTemplate && (
        <>
          <button
            type="button"
            aria-label="Back to template selection"
            onClick={resetTemplate}
            className={combineClasses(
              'flex items-center gap-1 w-full px-2 pt-1 pb-0.5',
              'text-frost-900 hover:text-frost-900 transition-colors cursor-pointer',
            )}
          >
            <ChevronLeftIcon className="size-4" />
             <DropdownMenuLabel
              className={combineClasses(LABEL_CLASSES, 'px-0 cursor-pointer')}
            >
              {selectedTemplate.title}
            </DropdownMenuLabel>
          </button>
           <DropdownMenuSeparator />
           <div className="flex px-2 pb-2 pt-1">
            {EXPORT_FORMATS.map((format, index) => (
              <button
                key={format}
                type="button"
                onClick={() => handleSelectFormat(format)}
                className={combineClasses(
                  'flex-1 py-1.5 text-xs sm:text-4xs font-medium sm:font-normal',
                  'border border-border transition-colors',
                  'text-frost-900 hover:bg-primary/80 hover:text-white',
                  index === 0 && 'rounded-l-md',
                  index === EXPORT_FORMATS.length - 1 && 'rounded-r-md',
                  index > 0 && 'border-l-0',
                )}
              >
                {format.toUpperCase()}
              </button>
            ))}
          </div>
        </>
       )} */}

      <div className="flex px-2 pb-2 pt-1">
        {EXPORT_FORMATS.map((format, index) => <button key={format} type="button" onClick={() => handleSelectFormat(format)} className={combineClasses('flex-1 py-1.5 text-xs sm:text-4xs font-medium sm:font-normal', 'border border-border transition-colors', 'text-frost-900 hover:bg-primary/80 hover:text-white', index === 0 && 'rounded-l-md', index === EXPORT_FORMATS.length - 1 && 'rounded-r-md', index > 0 && 'border-l-0')}>
            {format.toUpperCase()}
          </button>)}
      </div>
    </SidebarDropdown>;
};
export default ExportSidebarItem;